import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { Observable } from 'rxjs';
import { Role, RoleViewModel } from './role.model';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  constructor(private httpClient: HttpClient) { }

  delete(id: number): Observable<any> {
    return this.httpClient.delete<any>(`${AppConfig.settings.settings.apiEndpoint}api/Role/${id}`);
  }

  getDashboardPagesByRole(roleId: number): Observable<any> {
    return this.httpClient.get<any>(`${AppConfig.settings.settings.apiEndpoint}api/rolepermission/GetDashboardPagesByRoleId/${roleId}`);
  }

  getGenericRole(): Observable<any> {
    return this.httpClient.get<any>(`${AppConfig.settings.settings.apiEndpoint}api/Role/GetGenericRole`);
  }

  getRoleByClientId(clientId: number): Observable<RoleViewModel[]> {
    return this.httpClient.get<RoleViewModel[]>(`${AppConfig.settings.settings.apiEndpoint}api/Role/GetRoleByClientId/${clientId}`);
  }

  getRoleById(id: number): Observable<any> {
    return this.httpClient.get<any>(`${AppConfig.settings.settings.apiEndpoint}api/Role/${id}`);
  }

  getRolesByClientInfoId(clientInfoId: number): Observable<Role[]> {
    return this.httpClient.get<Role[]>(`${AppConfig.settings.settings.apiEndpoint}api/Role/GetRolesByClientInfoId/${clientInfoId}`);
  }

  post(model: RoleViewModel): Observable<boolean> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json', 'No-Error-Message': 'True' });
    return this.httpClient.post<boolean>(`${AppConfig.settings.settings.apiEndpoint}api/Role`, model, { headers: reqHeader });
  }

  put(id: number, model: RoleViewModel): Observable<boolean> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.put<boolean>(`${AppConfig.settings.settings.apiEndpoint}api/Role/${id}`, model, { headers: reqHeader });
  }
}
